import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { datadogRum } from '@datadog/browser-rum';
import { show } from '@intercom/messenger-js-sdk';

import {
  FONT_AWESOME_REGULAR,
  ICON_SET_FONTAWESOME,
} from 'constants-activate';
import { Button, Icon } from 'design-system-web';

import styles from './IntercomMessage.module.scss';

type Props = {
  forAdmin: boolean;
};

export function IntercomMessage({ forAdmin }: Props) {
  const { t } = useTranslation();

  const handleOpenChat = useCallback(() => {
    if (forAdmin) {
      return;
    }

    try {
      show();
    } catch (error) {
      datadogRum.addError(error, {
        component: 'IntercomMessage',
        intercomAction: 'messenger_show',
      });
    }
  }, [forAdmin]);

  return (
    <div className={styles.container} data-test="intercom-desktop-message">
      <div className={styles.card}>
        <div className={styles.iconCircle}>
          <Icon
            className={styles.headerIcon}
            name="comment-alt-smile"
            set={ICON_SET_FONTAWESOME}
            type={FONT_AWESOME_REGULAR}
            size="medium"
          />
        </div>

        <h2 className={styles.title}>
          {t('web.integrations.intercom.desktopMessage.title')}
        </h2>

        <p className={styles.message}>
          {t('web.integrations.intercom.desktopMessage.body')}
        </p>

        <div className={styles.ctaWrap}>
          <Button
            className={styles.ctaButton}
            disabled={forAdmin}
            endIcon={
              <Icon
                className={styles.ctaIcon}
                name="arrow-right"
                size="medium"
              />
            }
            onClick={handleOpenChat}
            size="medium"
            testId="intercom-open-support-chat"
            type="button"
            variant="primary"
          >
            {t('web.integrations.intercom.openChatCta')}
          </Button>
        </div>
      </div>
    </div>
  );
}
